import {
  FamilyBilling,
  FamilyStatus,
  Family as FamilyProto,
} from "protogen/advisors_service_pb";
import { PlatformFeeSchedule } from "protogen/billing_pb";
import {
  AccountStub,
  EntityMetadata,
  UserPermission as UserPermissionProto,
} from "protogen/common_pb";
import { BillingCoupon, BillingProduct } from "protogen/billing_pb";

export type UserPermission = {
  ref?: string;
  advisorRef: string;
  active: boolean;
  expiration: bigint | null;
  actions: { [key: string]: boolean };
  reactivate?: boolean;
  deactivate?: boolean;
  // Used for the UI
  account?: AccountStub;
};

export type Family = {
  ref?: string;
  name: string;
  advisorRef: string;
  status: FamilyStatus;
  startDate: string | null;
  clearStartDate?: boolean;
  endDate: string | null;
  clearEndDate?: boolean;
  permissions: UserPermission[];
  shouldUpdateBilling?: boolean;
  product?: BillingProduct;
  introCoupon?: BillingCoupon;
  platformFeeSchedule?: PlatformFeeSchedule;
  address?: string;
  billingInfo?: FamilyBilling;
  stripeCustomerId?: string;
  metadata?: EntityMetadata;
  signupSubmissionRef?: string;
  introCouponId?: string;
  productName?: string;
  isTestFamily?: boolean;
  lightningEnabled?: number;
};

export const familyProtoToFamily = (
  family: FamilyProto,
  advisorPermissions: UserPermissionProto[],
): Family => ({
  ref: family.ref,
  name: family.name,
  advisorRef: family.advisorRef,
  status: family.status,
  startDate: family.startDate || null,
  product: family.billingInfo?.product?.id
    ? family.billingInfo?.product
    : undefined,
  introCoupon: family.billingInfo?.introCoupon?.id
    ? family.billingInfo?.introCoupon
    : undefined,
  address: family.address,
  endDate: family.endDate || null,
  platformFeeSchedule: family.platformFeeSchedule,
  permissions: (advisorPermissions || []).map((permission) => ({
    ref: permission.ref,
    account: permission.account,
    advisorRef: permission?.account?.ref || "",
    active: permission.active,
    expiration: permission.expiration,
    actions: permission.actions,
  })),
  billingInfo: family.billingInfo,
  metadata: family.metadata,
  lightningEnabled: family.lightningEnabled,
});

export type Member = {
  ref?: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  altEmails: string[];
  timezone: string;
  isEphemeral?: boolean;
  activityNotificationEmailsEnabled: boolean;
};

export type FormErrors = {
  [key: string]: string;
};

export const prettyFamilyStatus = (status: FamilyStatus): string => {
  switch (status) {
    case FamilyStatus.ACTIVE:
      return "Active";
    case FamilyStatus.PROSPECT:
      return "Prospect";
    case FamilyStatus.DEMO:
      return "Demo";
    case FamilyStatus.TEST:
      return "Test";
    case FamilyStatus.DEACTIVATED:
      return "Deactivated";
    case FamilyStatus.DIGITAL_DEACTIVATED:
      return "Digital Deactivated";
    case FamilyStatus.DIGITAL_DEACTIVATED_TRIAL:
      return "Digital Trial Ended";
    case FamilyStatus.PREACTIVATION:
      return "Pre-Activation";
    case FamilyStatus.DEACTIVATED_PROSPECT:
      return "Deactivated Prospect";
    case FamilyStatus.UNPAID_SIGNUP:
      return "Free Signup";
    case FamilyStatus.DIGITAL_SUBSCRIPTION:
      return "Digital Subscription";
    default:
      return "";
  }
};
